import React from 'react';
import { SourcesProps } from './types';

const Sources = ({ sources }: SourcesProps) => (
  <>
    {sources.map(({ src, type }) => (
      <source role="source" key={Math.floor(Math.random() * 100)} src={src} type={type} />
    ))}
  </>
);

export default Sources;
